/**
 * components/UploadReminderBanner.js — slim top-of-page banner.
 *
 * Used on /transactions so the same reminder that appears on the
 * dashboard is echoed contextually where the user actually adds data.
 * Slimmer form-factor than UploadReminderTile: single line, inline CTA.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Upload, Clock, Calendar } from 'lucide-react';

const ICONS = {
  month_end: Calendar,
  new_month: Calendar,
  stale:     Clock,
};

export function UploadReminderBanner({ reminder }) {
  if (!reminder) return null;
  const Icon = ICONS[reminder.reason] || Upload;
  return (
    <div
      className="rounded-xl border border-primary/30 bg-primary/[0.04] p-3 flex items-center gap-3 flex-wrap"
      data-testid="upload-reminder-banner"
    >
      <div className="h-7 w-7 rounded-lg flex items-center justify-center shrink-0 bg-primary text-primary-foreground">
        <Icon className="h-3.5 w-3.5" />
      </div>
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-medium leading-snug">{reminder.title}</div>
        <div className="text-xs text-muted-foreground leading-relaxed mt-0.5">{reminder.message}</div>
      </div>
      <Link
        to={reminder.cta_href}
        className="text-xs font-medium text-primary hover:underline underline-offset-2 whitespace-nowrap ml-auto"
        data-testid="upload-reminder-banner-cta"
      >
        {reminder.cta} &rarr;
      </Link>
    </div>
  );
}

export default UploadReminderBanner;
